import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export const faqData = [
  {
    question: "¿Por qué elegir a R&M Estudio Contable en Corrientes Capital?",
    answer:
      "En R&M Estudio Contable brindamos atención personalizada y estratégica liderada por contadoras públicas matriculadas en Corrientes. Combinamos un profundo conocimiento de la normativa tributaria argentina y local (DGR Corrientes) con herramientas digitales que agilizan la gestión fiscal de empresas, PyMEs, profesionales y monotributistas."
  },
  {
    question: "¿Qué trámites y asesorías realizan ante AFIP y Rentas de Corrientes (DGR)?",
    answer:
      "Gestionamos altas, bajas y modificaciones en AFIP y Rentas Corrientes, liquidaciones mensuales y anuales de IVA, Impuesto a las Ganancias, Ingresos Brutos (Régimen General y Convenio Multilateral), confección de balances, moratorias y atención especializada ante intimaciones o inspecciones."
  },
  {
    question: "¿Realizan liquidación de sueldos y cargas sociales en Corrientes?",
    answer:
      "Sí. Realizamos la liquidación integral de haberes según el Convenio Colectivo de Trabajo (CCT) aplicable a su actividad, confección y presentación del Libro de Sueldos Digital (LSD), emisión de recibos oficiales y presentación mensual de cargas sociales (F.931) ante AFIP."
  },
  {
    question: "¿Ofrecen asesoramiento y gestión para Monotributistas y Emprendedores?",
    answer:
      "Absolutamente. Guiamos al emprendedor desde la elección óptima de su categoría, inscripción en AFIP y Rentas, configuración del punto de facturación electrónica, hasta el control periódico de ingresos y recategorizaciones semestrales obligatorias para evitar exclusiones de oficio."
  },
  {
    question: "¿Cómo coordinar una reunión o solicitar un presupuesto de honorarios contables?",
    answer:
      "Puede completar nuestro formulario de contacto en la web, escribirnos de forma directa por WhatsApp al +54 379 422-3834 o solicitar una entrevista diagnóstica (presencial en Corrientes Capital o virtual) para analizar las necesidades de su negocio sin compromiso."
  }
];

export const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="section-padding faq-section">
      <div className="container">
        <div className="text-center mb-5">
          <span className="faq-badge">Resolución de Dudas Frecuentes</span>
          <h2 style={{ marginTop: '0.75rem', fontSize: '2.2rem' }}>
            Preguntas Frecuentes sobre Contadores en Corrientes
          </h2>
          <p style={{ maxWidth: '750px', margin: '0.75rem auto 0', color: 'var(--color-text-muted)' }}>
            Respuestas clave sobre asesoría contable, impositiva y laboral para empresas, comercios y profesionales en Corrientes Capital.
          </p>
        </div>

        <div className="faq-container" style={{ maxWidth: '850px', margin: '0 auto' }}>
          {faqData.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={index} className={`faq-item ${isOpen ? 'active' : ''}`}>
                <button
                  type="button"
                  className="faq-question-btn"
                  onClick={() => toggleItem(index)}
                  aria-expanded={isOpen}
                >
                  <span className="faq-question-text">{item.question}</span>
                  <span className="faq-icon">
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                </button>
                {isOpen && (
                  <div className="faq-answer">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
